/** Sender context under a duplicate warning, or undefined when both fields are empty. */
export const formatPoolDepositDuplicateSender = (info) => [info.existingSenderName, info.existingSenderBankName]
    .filter(Boolean)
    .join(', ') || undefined;
/**
 * How far ahead of `now` a value may sit before it counts as future. Both
 * portals prefill the field with the browser's clock, which the server does
 * not share, so a plain `> now` rejects "now" whenever that clock runs ahead.
 */
export const POOL_PAYMENT_SENT_AT_CLOCK_SKEW_MS = 5 * 60 * 1000;
/**
 * When a payer says their wire left their bank: must parse, must not be in the
 * future beyond the clock-skew allowance. No lower bound, since an old wire can
 * legitimately be reconciled late. Shared by the API validator, the server's
 * Joi schemas, business-web's zod and admin's yup. `now` is injectable so a
 * test can pin the boundary.
 */
export const validatePoolPaymentSentAt = (
// `null` because that is what a yup `.test` hands its predicate when unset.
value, options) => {
    if (value === undefined || value === null) {
        return 'missing';
    }
    if (typeof value === 'string' && !value.trim()) {
        return 'missing';
    }
    const parsed = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return 'invalid';
    }
    const now = options?.now ?? new Date();
    if (parsed.getTime() > now.getTime() + POOL_PAYMENT_SENT_AT_CLOCK_SKEW_MS) {
        return 'future';
    }
    return undefined;
};
/** One message per rule, so every surface phrases a rejection identically. */
export const POOL_PAYMENT_SENT_AT_MESSAGES = {
    missing: 'Enter the date and time the payment was sent',
    invalid: 'Enter a valid date and time',
    future: 'The payment time cannot be in the future',
};
//# sourceMappingURL=poolDepositUtils.js.map